// Used for getting config data.
export const getSettingsConfig = (arr, name) => {
    return arr?.find((setting) => setting.configKey === name);
};
